import { render, staticRenderFns } from "./LabourRateAdd.vue?vue&type=template&id=65306348"
import script from "./LabourRateAdd.vue?vue&type=script&lang=ts"
export * from "./LabourRateAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports